// Exchange rates entered by hand (admin-only on the backend)
import api, { type AxiosResponse } from './client';
import type { ExchangeRateRow } from './types';

export const exchangeRatesAPI = {
  /**
   * Store a rate typed in by an admin: 1 GBP = `rate` units of `currency`,
   * effective from `rate_date`. Replaces a rate already stored for that date.
   *
   * @param data - currency code, rate as a decimal string, effective date (YYYY-MM-DD)
   * @returns the stored rate
   */
  addManualRate: (data: { currency: string; rate: string; rate_date: string }): Promise<AxiosResponse<ExchangeRateRow>> =>
    api.post('/core/exchange-rates/manual/', data),
};
